<div class='flex container'>
    <mat-card>
        <div class='row'>
            <div class='offset-md-1 col-md-3 col-6'>
                <h4><b>Tank: Toilet Bldg</b></h4>
                <h4>SubId : 129789</h4>
                <h4>Last Update</h4>
                <button mat-stroked-button class="btn" style='font-size: small;'>Watter 20%<br /> Flow 35%</button>
            </div>
            <div class='col-md-3 col-6'>
                <img src='assets/images/tank.jpg' alt='..' style='width: 100%; height: 200px;' />
            </div>
            <div class='offset-md-1 col-md-4 col-6'>
                <h4>Last 5 Events</h4>
                <table class='table table-responsive table-lg'>
                    <tbody>
                        <tr>
                            <td>{{2020 - 01 -12 | date}}</td>
                            <td>Low</td>
                        </tr>
                        <tr>
                            <td>{{2020 - 01 -12 | date}}</td>
                            <td>Low</td>
                        </tr>
                        <tr>
                            <td>{{2020 - 01 -12 | date}}</td>
                            <td>Low</td>
                        </tr>
                        <tr>
                            <td>{{2020 - 01 -12 | date}}</td>
                            <td>Low</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </mat-card>
</div>